import { render, staticRenderFns } from "./StudentViewStudentTimelineCard.vue?vue&type=template&id=47a6004a&"
import script from "./StudentViewStudentTimelineCard.vue?vue&type=script&lang=js&"
export * from "./StudentViewStudentTimelineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports